var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inital)?_c('div',[_c('notifications'),(_vm.user)?_c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_vm._l((_vm.$route.query),function(card,key){return [(_vm.items[key])?_c(key,{key:key,tag:"component",style:({
            zIndex: _vm.priority[key] ? _vm.priority[key] : 3,
          }),attrs:{"id":card}}):_vm._e()]}),_c('router-view')],2):_c('div',[_c('login')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }